<template>
  <div :class="$style.outer">
    <slot name="outer">
      <Anicss :enter-active-class="['animated', 'fadeIn']" :leave-active-class="['animated', 'fadeOut']">
        <VideoPlayer
          ref="player"
          v-show="showVideo"
          @close="stopVideo"
          @ended="ended"
          :files="videos"
        />
      </Anicss>
    </slot>
    <div :class="$style.root" :style="rootStyle">
      <div :class="$style.title">
        <slot></slot>
      </div>
      <slot name="next-icon">
        <SvgIcon
          :class="$style.skip"
          :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/skip-next.svg')"
          button
          @click="handleSkip"
          v-show="showControls"
        />
      </slot>
      <slot name="after">
        <SvgIcon
          :class="$style.play"
          :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/video.svg')"
          button
          v-show="showControls"
          @click="playVideo"
        />
      </slot>
    </div>
  </div>
</template>

<script>
import SvgIcon from '../SvgIcon'
import Anicss from '../Anicss'
import VideoPlayer from '../VideoPlayer'

export default {
  components: {
    SvgIcon,
    Anicss,
    VideoPlayer,
  },
  props: {
    bgColor: {
      type: String,
    },
    videos: {
      type: Array,
    },
  },
  data () {
    return {
      inited: false,
      timer: null,
      showVideo: false,
    }
  },
  mounted () {
    this.timer = setTimeout(() => {
      this.inited = true
      this.playVideo()
      this.$emit('init')
    }, 1000)
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  computed: {
    rootStyle () {
      return {
        'background-color': this.bgColor,
      }
    },
    showControls () {
      return this.inited
    },
  },
  methods: {
    handleSkip () {
      this.$emit('skip')
    },
    playVideo () {
      this.showVideo = true
      this.$refs.player.play()
    },
    stopVideo () {
      this.showVideo = false
      this.$refs.player.stop()
    },
    ended () {
      this.stopVideo()
      setTimeout(() => {
        this.handleSkip()
      }, 1500)
    },
  },
}
</script>

<style lang="scss" module>
.outer {
  @apply h-full;
}

.root {
  @apply relative;
  @apply rounded-lg;
  @apply flex;
  @apply items-center;
  @apply justify-center;
  @apply h-full;
}

.title {
  font-size: 7rem;
}

.skip {
  @apply absolute;
  bottom: 0;
  right: 0;
  @apply m-4;
}

.play {
  @apply absolute;
  @apply bottom-0;
  @apply right-0;
  @apply m-4;
  @apply mr-20;
}
</style>
